import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import style from './IconButton.module.scss';

export default function IconButton(
  {
    icon,
    type,
    onClick,
  },
) {
  return (
    <button
      type={type !== 'submit' ? 'button' : 'submit'}
      onClick={onClick}
      className={clsx(style.button)}
    >
      <div className={clsx(style.button__icon)}>
        {icon}
      </div>
    </button>
  );
}

IconButton.propTypes = {
  icon: PropTypes.element.isRequired,
  type: PropTypes.string,
  onClick: PropTypes.func,
};

IconButton.defaultProps = {
  type: 'button',
  onClick: null,
};
